import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function PortalAutoLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      localStorage.setItem('customerToken', token);
      navigate('/portal', { replace: true });
    } else {
      navigate('/portal', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div style={{ background: '#09090b', color: '#fff', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p>Anmeldung läuft...</p>
    </div>
  );
}
